import { INavLink } from "core-integration/src/hooks/types";
import React from "react";
import { NavLink } from "react-router";
import "./ListItem.css";

const ListItem = React.forwardRef<HTMLLIElement, INavLink>(
  ({ useRouter, text, href, rel, isDraft, target }, ref) => {
    return (
      <li ref={ref}>
        {useRouter ? (
          <NavLink
            to={href}
            className={({ isActive }) =>
              isActive ? `ism-nav__tab active` : `ism-nav__tab`
            }
          >
            {text}
          </NavLink>
        ) : (
          <a
            href={href}
            className={`ism-nav__tab ${isDraft && "isAlt"}`}
            rel={rel}
            target={target}
          >
            <span>{text}</span>
          </a>
        )}
      </li>
    );
  },
);

export default ListItem;
